module.exports = __webpack_public_path__ + "img/ezgif.com-gif-maker-F.4782eb36.png";